export default "__VITE_ASSET__dbb2308e__"